
import React from 'react';
import { GoDownload } from "react-icons/go";
import { RiFolderVideoFill } from "react-icons/ri";


const DownloadList = ({ downloads }) => {
  return (
    <div className="download-list">
      {downloads.map((item, idx) => (
        <div className="download-item" key={idx}>
          <div className="file-icon">
            <span className="play-icon"><RiFolderVideoFill /></span>
          </div>
          <div className="file-details">
            <div className="file-name">{item.name}</div>
            <div className="file-meta">{item.size} • {item.date}</div>
          </div>
          <div className="download-icon">
            <span className="download-btn"><GoDownload /></span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DownloadList;
